import { render, staticRenderFns } from "./CreateEdit.vue?vue&type=template&id=671c5ea4&scoped=true"
import script from "./CreateEdit.vue?vue&type=script&lang=js"
export * from "./CreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c5ea4",
  null
  
)

export default component.exports